/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-select';

/**
 * The error thrown when trying to use children other than <Option>.
 * @type {String}
 */
export const OPTION_CHILD_ERROR = 'Only <Select.Option> components are valid children of <Select>';

/**
 * The window's load event.
 * @type {String}
 */
export const LOAD_EVENT = 'load';

/**
 * The document's ready state.
 * @type {String}
 */
export const COMPLETE = 'complete';
